import { render, staticRenderFns } from "./logisticsOrderList.vue?vue&type=template&id=7820f7c6&scoped=true"
import script from "./logisticsOrderList.vue?vue&type=script&lang=js"
export * from "./logisticsOrderList.vue?vue&type=script&lang=js"
import style0 from "./logisticsOrderList.vue?vue&type=style&index=0&id=7820f7c6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820f7c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7820f7c6')) {
      api.createRecord('7820f7c6', component.options)
    } else {
      api.reload('7820f7c6', component.options)
    }
    module.hot.accept("./logisticsOrderList.vue?vue&type=template&id=7820f7c6&scoped=true", function () {
      api.rerender('7820f7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderManagement/logisticsOrderList/logisticsOrderList.vue"
export default component.exports